function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{fill:#231F20;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M16.653,14.444c-0.589,0.878-1.331,1.62-2.209,2.209c-0.229,0.153-0.291,0.464-0.137,0.693 c0.096,0.144,0.254,0.222,0.415,0.222c0.096,0,0.193-0.027,0.278-0.085c0.986-0.661,1.821-1.496,2.482-2.482 c0.154-0.229,0.093-0.54-0.137-0.693C17.118,14.153,16.806,14.215,16.653,14.444z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M15.001,2.517c-0.23-0.153-0.54-0.093-0.694,0.138c-0.153,0.229-0.092,0.54,0.138,0.693 c0.877,0.587,1.62,1.33,2.209,2.208c0.096,0.144,0.254,0.222,0.415,0.222c0.096,0,0.192-0.027,0.278-0.084 c0.229-0.154,0.291-0.464,0.137-0.694C16.822,4.012,15.987,3.177,15.001,2.517z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M4.999,2.516C4.012,3.177,3.177,4.013,2.517,4.999c-0.154,0.229-0.092,0.54,0.137,0.694 C2.739,5.75,2.836,5.777,2.932,5.777c0.161,0,0.319-0.078,0.416-0.222c0.587-0.877,1.33-1.62,2.208-2.208 c0.229-0.154,0.291-0.464,0.137-0.694C5.539,2.424,5.227,2.363,4.999,2.516z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M3.347,14.444c-0.154-0.229-0.465-0.292-0.694-0.137c-0.229,0.153-0.291,0.464-0.137,0.693 c0.661,0.986,1.496,1.821,2.482,2.482c0.085,0.058,0.182,0.085,0.278,0.085c0.161,0,0.319-0.078,0.416-0.222 c0.153-0.229,0.092-0.54-0.137-0.693C4.678,16.064,3.935,15.321,3.347,14.444z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M1.76,7.852C1.491,7.793,1.226,7.974,1.172,8.244C1.058,8.814,1,9.404,1,10c0,0.596,0.058,1.187,0.171,1.757 c0.047,0.238,0.256,0.403,0.49,0.403c0.032,0,0.065-0.004,0.098-0.01c0.271-0.055,0.447-0.318,0.393-0.588 C2.052,11.055,2,10.53,2,10c0-0.529,0.051-1.054,0.152-1.56C2.207,8.169,2.031,7.905,1.76,7.852z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M11.562,17.849c-1.024,0.201-2.099,0.201-3.124,0c-0.271-0.057-0.534,0.123-0.587,0.394 c-0.053,0.271,0.124,0.534,0.395,0.587C8.821,18.942,9.412,19,10,19s1.179-0.058,1.754-0.171c0.271-0.053,0.447-0.315,0.394-0.587 C12.095,17.972,11.834,17.792,11.562,17.849z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M18.828,8.245c-0.054-0.271-0.312-0.45-0.588-0.393c-0.271,0.054-0.446,0.317-0.393,0.587 C17.948,8.949,18,9.474,18,10c0,0.526-0.052,1.052-0.152,1.562c-0.054,0.271,0.122,0.534,0.393,0.588 c0.033,0.006,0.065,0.01,0.099,0.01c0.233,0,0.442-0.165,0.489-0.403C18.942,11.182,19,10.591,19,10 C19,9.409,18.942,8.818,18.828,8.245z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M11.755,1.171c-1.151-0.228-2.356-0.228-3.511,0C7.974,1.225,7.797,1.487,7.851,1.758 c0.047,0.238,0.256,0.403,0.49,0.403c0.032,0,0.064-0.003,0.097-0.009c1.027-0.203,2.099-0.203,3.123,0 c0.273,0.054,0.534-0.123,0.587-0.394C12.202,1.488,12.026,1.225,11.755,1.171z"
}));

function SvgInProgress(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInProgress);
export default __webpack_public_path__ + "static/media/in_progress.c071a051.svg";
export { ForwardRef as ReactComponent };